var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"compliance-severity-container"},[_c('div',{staticClass:"compliance-severity-text",style:(_vm.style)},[_vm._v(" "+_vm._s(_vm.getSeverity)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }